/**
 * @generated SignedSource<<7ad8979cc21b74784470180905fd8dd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditInvoiceDeleteMutation$variables = {
  id: string;
};
export type OrderEditInvoiceDeleteMutation$data = {
  readonly deleteOrderInvoice: {
    readonly invoice: {
      readonly " $fragmentSpreads": FragmentRefs<"StoredFile_file">;
    } | null;
  };
};
export type OrderEditInvoiceDeleteMutation = {
  response: OrderEditInvoiceDeleteMutation$data;
  variables: OrderEditInvoiceDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderEditInvoiceDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "deleteOrderInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoredFile_file"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrderEditInvoiceDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "deleteOrderInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "76a2b138aa15fc36e9bddc1d40f1fd88",
    "id": null,
    "metadata": {},
    "name": "OrderEditInvoiceDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrderEditInvoiceDeleteMutation(\n  $id: ID!\n) {\n  deleteOrderInvoice(id: $id) {\n    invoice {\n      ...StoredFile_file\n      id\n    }\n    id\n  }\n}\n\nfragment StoredFile_file on StoredFile {\n  fileName\n  size\n}\n"
  }
};
})();

(node as any).hash = "2cbf3e4549f382e72ba866b11764b46c";

export default node;
